import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary'; // ✅ Import karo

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ✅ App ko ErrorBoundary ke andar lapet do */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);